import React, {ReactElement} from "react";
import {Link, useLocation} from "react-router-dom";
import {getClients} from "../services/ServiceClients";
import IClient from "../interfaces/IClient";
import {Col, ConfigProvider, Typography} from "antd";
import ClientIcon from "../components/ClientIcon";

const { Text } = Typography

export default function Success(): ReactElement | null {

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    // Variables
    const query = useQuery();
    const client = query.get("client_id");

    const { clients } = getClients();
    const clientDetails: IClient = clients?.find((cl) => cl.id === client)!;

    const onClick = () => {
        window.top!.location.href = `${window.userprofile.url}/${window.userprofile.path.logout}?${query}`;
    }

    return (
        <div className="container">
            <ConfigProvider theme={{token: { colorPrimary: clientDetails?.color ?? "" }}}>
                <Col>
                    <Col className="icon-col">
                        <ClientIcon client={clientDetails} size={100} />
                    </Col>
                    <Col>
                        <Text style={{fontSize: "large"}}>Bienvenue sur {clientDetails?.name} !</Text>
                    </Col>
                    <Col>
                        <Text>Pour vous déconnecter, cliquez sur ce lien : <Text onClick={onClick} style={{color: clientDetails?.color ?? "", cursor: "pointer"}}>déconnexion</Text>.
                        </Text>
                    </Col>
                </Col>
            </ConfigProvider>
        </div>
    )
}